<template>
    <div class="template_wrapper">
        <div class="template_title"><span style="color:red;" v-if="moduel.required==1 " >*</span>{{moduel.name}}</div>
        <el-select  v-model="name" placeholder="请选择" @change="getId">
            <el-option
             v-for="(item,key) in moduel.select_obj"
            :key="key"
            :lable="item.name"
            :value="item.name">
            </el-option>
        </el-select>
        <!-- <span style="color:red;" v-if="moduel.required==1  && type!='audit' " >*</span> -->
    </div>
</template>
<style>

</style>
<script>
export default {
  name: 'selects',
  data () {
    return {
        name:'',
        saving: false,
        disabled:false
    }
  },
  props: ['moduel', 'projectData','type'],
  methods:{
      getId(){
          if(this.saving) return;
          this.saving = true;
          for(var i =0; this.moduel.select_obj.length > i; i++){
            if(this.moduel.select_obj[i].name == this.name){
                this.$emit('input', this.moduel.select_obj[i].id);
                 console.log(this.moduel.select_obj[i].id)
            }
          }
          var that = this;
          this.$emit('listenToChildEvent',this.type, function(){
            that.saving = false;
          });

          // if(this.page == 'Briefing' && this.moduel.key_name == 'project_id' ){
          //     this.$emit('listenToChildEvent', this.moduel.select_obj[i].id);
          // }
          // if(this.page == 'docuement' && this.moduel.key_name == 'project_id' ){
          //     this.$emit('listenToChildEvent');
          // }
          // if(this.page == 'approval' && this.moduel.key_name == 'project_id' ){
          //   this.$emit('listenToChildEvent');
          // }
      },
      clear(){
           this.name = ''
      }
  },
  created() {
     console.log(this.moduel)
      if(this.projectData[this.moduel.key_name] != ''){
        if(this.projectData[this.moduel.key_name] !=null){
          this.id = this.projectData[this.moduel.key_name];
          for(var i =0; this.moduel.select_obj.length > i; i++){
            if(this.moduel.select_obj[i].id == this.id){
                this.name = this.moduel.select_obj[i].name;
            }
          }
        }
      }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/c-select.vue